import axios from "../utils/axios";

export const getAllRestaurantsApi = (search = "") => {
  return axios.get(`/api/admin/restaurants?search=${search}`, {
    withCredentials: true,
  });
};

export const getRestaurantDetailsApi = (id) =>
  axios.get(`/api/admin/restaurants/${id}`, {
    withCredentials: true,
  });
